<template>
  <ServicePageLayout
    icon="fas fa-briefcase"
    title="Career & Job Placement"
    subtitle="Preparing students for successful careers and meaningful employment"
  >
    <section class="content-section">
      <h2>
        <i class="fas fa-info-circle section-icon" />
        Overview
      </h2>
      <p>
        The Career and Job Placement Office bridges the gap between academic preparation and
        professional success. We connect students with internship opportunities, career resources,
        and potential employers to help launch successful careers.
      </p>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-list-check section-icon yellow" />
        Services Offered
      </h2>
      <div class="services-grid">
        <div class="service-card">
          <div class="card-icon yellow">
            <i class="fas fa-search" />
          </div>
          <h3>Job Matching</h3>
          <p>Connect with employers looking for fresh graduates and skilled professionals.</p>
        </div>
        <div class="service-card">
          <div class="card-icon green">
            <i class="fas fa-file-alt" />
          </div>
          <h3>Resume Building</h3>
          <p>Professional guidance on creating compelling resumes and cover letters.</p>
        </div>
        <div class="service-card">
          <div class="card-icon yellow">
            <i class="fas fa-comments" />
          </div>
          <h3>Interview Prep</h3>
          <p>Mock interviews and coaching to boost your confidence and skills.</p>
        </div>
        <div class="service-card">
          <div class="card-icon green">
            <i class="fas fa-handshake" />
          </div>
          <h3>Internship Programs</h3>
          <p>Partnerships with companies for hands-on industry experience.</p>
        </div>
        <div class="service-card">
          <div class="card-icon yellow">
            <i class="fas fa-calendar-check" />
          </div>
          <h3>Job Fairs</h3>
          <p>Regular career events connecting students with potential employers.</p>
        </div>
        <div class="service-card">
          <div class="card-icon green">
            <i class="fas fa-chart-line" />
          </div>
          <h3>Career Assessment</h3>
          <p>Aptitude tests and career counseling to find your ideal path.</p>
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-building section-icon yellow" />
        Partner Companies
      </h2>
      <p class="mb-1">
        We maintain partnerships with leading companies across various industries:
      </p>
      <div class="partners-grid">
        <div class="partner-badge">
          Technology
        </div>
        <div class="partner-badge">
          Healthcare
        </div>
        <div class="partner-badge">
          Finance
        </div>
        <div class="partner-badge">
          Education
        </div>
        <div class="partner-badge">
          Manufacturing
        </div>
        <div class="partner-badge">
          Government
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-calendar-alt section-icon yellow" />
        Office Hours
      </h2>
      <div class="schedule-card">
        <div class="schedule-row">
          <span class="day">Monday - Friday</span>
          <span class="time yellow">8:00 AM - 5:00 PM</span>
        </div>
        <div class="schedule-row">
          <span class="day">Saturday</span>
          <span class="time yellow">8:00 AM - 12:00 PM</span>
        </div>
        <div class="schedule-row">
          <span class="day">Sunday</span>
          <span class="time yellow">Closed</span>
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-phone section-icon yellow" />
        Contact Information
      </h2>
      <div class="contact-grid">
        <div class="contact-item">
          <i class="fas fa-map-marker-alt" />
          <span>Room 205, Student Services Building</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-phone" />
          <span>(078) 123-4567 Local 205</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-envelope" />
          <span>career@nc.edu.ph</span>
        </div>
      </div>
    </section>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/landing/ServicePageLayout.vue'

export default {
  name: 'CareerService',

  components: {
    ServicePageLayout
  },

  metaInfo: () => ({
    title: 'Career & Job Placement'
  })
}
</script>
